import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9qqlp5kqt7: FaireBrandEntity = {
  token: "b_9qqlp5kqt7",
  type: "brand",
  name: "UNISHE",
  avatarUrl:
    "https://cdn.faire.com/fastly/3a811d46ac78bd29be6c065f57665ef3607b0ef257c23c332dc0cf5ac8c4ad46.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ebda4242ca0c3c772557ca7be4d098f309034aef5bb490a9a2604b383c99f57d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3a811d46ac78bd29be6c065f57665ef3607b0ef257c23c332dc0cf5ac8c4ad46.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ebda4242ca0c3c772557ca7be4d098f309034aef5bb490a9a2604b383c99f57d.png",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.1,
  reviewCount: 2496,
  isInsider: false,
  description:
    "UNISHE: Your Trusted Fashion Wholesaler\n\nAt UNISHE, we are committed to helping our customers thrive—because when you succeed, we succeed. As a leading fashion wholesaler with a professional factory, we release new styles every week and have proudly partnered with over 15,500 retailers on Faire.\n\nShop with confidence—we stand behind our products and always make things right if any issues arise on our end.\n\nFlexible & Efficient Shipping\nOrders may be fulfilled from either our USA warehouse or China factory, depending on inventory availability. This flexibility helps us minimize delays and keep your business running smoothly. No worries—we cover any extra shipping costs and duties to the USA for shipments from our China factory.\n\nLead Time & Urgent Requests\nOur standard lead time is 11-14 days. Need a faster turnaround? Just message us, and our dedicated customer service team will do their best to accommodate your request.\n\nThank you for choosing UNISHE—we're here to support your business every step of the way!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:09.030Z",
    importedBy: "entity-db-cli",
  },
};
